import React, { useState } from "react";
import { Link } from "react-router-dom";
import AnswersLikeDislikeBox from "./AnswersLikeDislikeBox";
import Tooltip from "@mui/material/Tooltip";
import "./PaginationCss.css";

function QuestionAnswereBox({ AllserviceQuestion }) {
  // console.log(AllserviceQuestion);
  const [currentPage, setCurrentPage] = useState(1);
  const questionsPerPage = 5; // Number of questions per page

  const totalPages = Math.ceil(AllserviceQuestion.length / questionsPerPage);
  const indexOfLastQuestion = currentPage * questionsPerPage;
  const indexOfFirstQuestion = indexOfLastQuestion - questionsPerPage;
  const currentQuestions = AllserviceQuestion.slice(
    indexOfFirstQuestion,
    indexOfLastQuestion
  );

  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    if (
      i === 1 ||
      i === totalPages ||
      (i >= currentPage - 1 && i <= currentPage + 1)
    ) {
      pageNumbers.push(i);
    } else if (pageNumbers[pageNumbers.length - 1] !== "...") {
      pageNumbers.push("...");
    }
  }
  return (
    <>
      {currentQuestions.length > 0 ? (
        currentQuestions.map((quesValue, index) => (
          <div className="formdesedataBOX quesAnsBoxBorder" key={index}>
            <div className="quesansheading">
              <h4>
                <i
                  className="fa fa-question-circle headingsiteIcon"
                  aria-hidden="true"
                ></i>{" "}
                {quesValue.subject}
              </h4>
              <span className="fw-100 question_AddDate">
                {" "}
                {quesValue.question_add_date}
              </span>
            </div>

            <p className="fw-600 formdescPera mb-0">
              In {quesValue.community_subservice}
            </p>
            <p className="formdescPera mb-1 quesAnsPera">
              {quesValue.question}
            </p>

            <div className="formdesctitlebox pb-0">
              <div className="formDatarow">
                <Link
                  to={`/advice-question/${quesValue.question_slug}`}
                  className="sencondBTNhover mb-3"
                >
                  Read More
                </Link>
              </div>
            </div>
          </div>
        ))
      ) : (
        <div className="text-center notfountCommunityQues">
          <p className="NotFountHeading">No Question Found.</p>
          <p>
            Get <Link to="/free-advice">free legal advice</Link> from top-rated
            lawyers in India.
          </p>
        </div>
      )}

      {/* Pagination Controls */}
      {totalPages > 1 && (
        <div className="pagination-controls text-center mt-5">
          <button
            className="pagination-btn"
            disabled={currentPage === 1}
            onClick={() => setCurrentPage(currentPage - 1)}
          >
            ◄
          </button>
          {pageNumbers.map((number, index) => (
            <button
              key={index}
              className={`pagination-btn ${
                number === currentPage ? "active" : ""
              }`}
              onClick={() => number !== "..." && setCurrentPage(number)}
              disabled={number === "..."}
            >
              {number}
            </button>
          ))}
          <button
            className="pagination-btn"
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage(currentPage + 1)}
          >
            ►
          </button>
        </div>
      )}
    </>
  );
}

function QuestionBox({ serviceQues }) {
  return (
    <>
      {" "}
      <div className="formdesedataBOX quesAnsBoxBorder">
        <div className="quesansheading">
          <h4 className="">
            <i
              className="fa fa-question-circle headingsiteIcon"
              aria-hidden="true"
            ></i>
            {serviceQues.subject}
          </h4>
          <span className="fw-100 question_AddDate">
            {" "}
            ({serviceQues.question_add_date})
          </span>
        </div>
        <p className="formdescPera my-3">{serviceQues.question}</p>
      </div>
    </>
  );
}

function AnswersBox({ RendomTokenfetch, communitySerAns, QuestionID }) {
  const [currentPage, setCurrentPage] = useState(1);
  const questionsPerPage = 5; // Number of questions per page

  const totalPages = Math.ceil(communitySerAns.length / questionsPerPage);
  const indexOfLastQuestion = currentPage * questionsPerPage;
  const indexOfFirstQuestion = indexOfLastQuestion - questionsPerPage;
  const currentQuestions = communitySerAns.slice(
    indexOfFirstQuestion,
    indexOfLastQuestion
  );

  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    if (
      i === 1 ||
      i === totalPages ||
      (i >= currentPage - 1 && i <= currentPage + 1)
    ) {
      pageNumbers.push(i);
    } else if (pageNumbers[pageNumbers.length - 1] !== "...") {
      pageNumbers.push("...");
    }
  }

  const getVideoId = (url) => {
    const urlObj = new URL(url);
    return urlObj.searchParams.get("v"); // Extracts 'v' parameter
  };

  return (
    <>
      {currentQuestions.length > 0 &&
        currentQuestions.map((ansValue, index) => (
          <div className="formdesedataBOX AnswersBoxBorder" key={index}>
            <div className="quesAnsheadingbox">
              <p className="answerecounttext fw-600 mb-0">
                Answers #{index + 1}{" "}
                <span className="fw-100 answers_AddDate">
                  {" "}
                  ({ansValue.date})
                </span>
              </p>
              <div className="helpfullbos d-flex">
                {ansValue.video_url && (
                  <div className="videoplaybox mx-2">
                    <Tooltip title="Play" placement="top" arrow>
                      <Link
                        to={ansValue.video_url}
                        data-fancybox
                        data-caption="Video"
                        className="playvideobtn"
                      >
                        <i className="fa fa-play-circle" aria-hidden="true"></i>
                      </Link>
                    </Tooltip>
                  </div>
                )}
                <AnswersLikeDislikeBox
                  RendomTokenfetch={RendomTokenfetch}
                  AnsID={ansValue.id}
                  QuesID={QuestionID}
                  likeCount={ansValue.answerliks}
                  likeStatus={ansValue.userlikestatus}
                />
              </div>
            </div>
            <div className="formdesctitlebox">
              <div className="formDatarow">
                <p
                  className="formdescPera my-3 p-0"
                  dangerouslySetInnerHTML={{
                    __html: ansValue.answer,
                  }}
                ></p>

                {ansValue.video_url && (
                  <div className="answervideobox my-3">
                    <iframe
                      width="445"
                      height="250"
                      src={`https://www.youtube.com/embed/${getVideoId(
                        ansValue.video_url
                      )}`}
                      title="YouTube video player"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      allowFullScreen
                      referrerPolicy="strict-origin-when-cross-origin"
                    ></iframe>
                  </div>
                )}

                <div className="answersvakilfrofile mb-3">
                  <div className="advocatefroflebox">
                    {ansValue.userimg && ansValue.userimg ? (
                      <img src={ansValue.userimg} alt="" />
                    ) : (
                      <img src="../images/blankUser.png" alt="" />
                    )}

                    <div className="advocatenaembox">
                      <h5>{ansValue.username}</h5>
                      <p className="mb-0">
                        <span>
                          <i
                            className="fa fa-map-marker"
                            aria-hidden="true"
                          ></i>
                        </span>
                        <span> {ansValue.city}</span>
                        <span></span>
                      </p>
                    </div>
                  </div>
                  <Link className="sencondBTNhover">Contect now</Link>
                </div>
              </div>
            </div>
          </div>
        ))}

      {/* Pagination Controls */}
      {totalPages > 1 && (
        <div className="pagination-controls text-center mt-5">
          <button
            className="pagination-btn"
            disabled={currentPage === 1}
            onClick={() => setCurrentPage(currentPage - 1)}
          >
            ◄
          </button>
          {pageNumbers.map((number, index) => (
            <button
              key={index}
              className={`pagination-btn ${
                number === currentPage ? "active" : ""
              }`}
              onClick={() => number !== "..." && setCurrentPage(number)}
              disabled={number === "..."}
            >
              {number}
            </button>
          ))}
          <button
            className="pagination-btn"
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage(currentPage + 1)}
          >
            ►
          </button>
        </div>
      )}
    </>
  );
}

export default QuestionAnswereBox;
export { QuestionBox, AnswersBox };
